export function resolveAdminCreditAdjustment({ amount, direction, currency = 'TRY', originalCredit, eurEnabled = false, eurTryRate }) {
  const raw = String(amount ?? '').trim();
  const balance = Number(originalCredit);
  const base = { hasAmount: raw !== '', valid: false, nativeAmount: null, deltaTry: 0, nextCredit: balance, error: '' };
  const invalid = (error) => ({ ...base, error });

  if (!Number.isFinite(balance) || balance < 0) return invalid('Mevcut bakiye doğrulanamadı.');
  if (!['add', 'subtract'].includes(direction)) return invalid('Kredi Ekle veya Kredi Düş seçin.');
  if (!raw) return invalid('Tutar girin.');
  if (!/^\d+(?:[.,]\d{1,2})?$/.test(raw)) return invalid('Pozitif bir tutar girin.');
  const magnitude = Number(raw.replace(',', '.'));
  if (!Number.isFinite(magnitude) || magnitude <= 0) return invalid('Sıfırdan büyük bir tutar girin.');
  if (!['TRY', 'EUR'].includes(currency)) return invalid('Geçerli bir para birimi seçin.');
  if (currency === 'TRY' && !Number.isInteger(magnitude)) return invalid('TL tutarı tam sayı olmalı.');
  const rate = currency === 'EUR' ? Number(eurTryRate) : 1;
  if (currency === 'EUR' && (!eurEnabled || !Number.isFinite(rate) || rate <= 0)) return invalid('Euro kuru doğrulanamadı.');

  const magnitudeTry = Math.round(magnitude * rate);
  if (!Number.isSafeInteger(magnitudeTry) || magnitudeTry <= 0) return invalid('Geçerli bir tutar girin.');
  if (direction === 'subtract' && magnitudeTry > balance) return invalid('Düşülecek tutar mevcut bakiyeyi aşamaz.');
  const sign = direction === 'subtract' ? -1 : 1;
  const nextCredit = balance + sign * magnitudeTry;
  if (!Number.isFinite(nextCredit) || nextCredit > Number.MAX_SAFE_INTEGER) return invalid('Tutar çok büyük.');
  return { ...base, valid: true, nativeAmount: sign * magnitude, deltaTry: sign * magnitudeTry, nextCredit };
}
